import { NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OfferDetailsPageRoutingModule } from './offer-details-page-routing.module';
import { OfferDetailsPageComponent } from './offer-details-page/offer-details-page.component';
import { OfferDetailModule } from 'abs-ngx-library/src/lib/offer-detail';
import { OfferQualifiedProductsModule } from 'abs-ngx-library/src/lib/offer-qualified-products';
import { CartService, OfferDetailService, CoreModule } from 'abs-ngx-library/src/lib/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { OfferDetailCardComponent } from './offer-detail-card/offer-detail-card.component';
import { BannerUnitModule } from "abs-ngx-library/src/lib/banner-unit";


@NgModule({
  declarations: [
    OfferDetailsPageComponent,
    OfferDetailCardComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    OfferDetailsPageRoutingModule,
    OfferDetailModule,
    OfferQualifiedProductsModule,
    CoreModule.forRoot({appName: null, programType: 'abs'}),
    BannerUnitModule
  ],
  providers: [
    OfferDetailService,
    CartService
  ],
  schemas: [NO_ERRORS_SCHEMA]
})
export class OfferDetailsPageModule { }
